import React from "react";
import { AlertTriangle } from "lucide-react";
import { TYPES, short12, timeRange, duration } from "./calUtils";

export function EventChip({ it, onOpen, compact }) {
  const st = TYPES[it.type] || TYPES.event;
  const clash = (it.conflicts || []).length > 0;
  const base = "w-full text-left truncate text-[11px] leading-tight px-1.5 py-0.5 rounded-md flex items-center gap-1 transition-transform hover:scale-[1.02] focus:outline-none focus-visible:ring-2 focus-visible:ring-teal";
  const click = (e) => { e.stopPropagation(); onOpen(it); };
  if (it.all_day) {
    return (
      <button type="button" data-testid={`cal-item-${it.uid}`} onClick={click} title={it.title}
        className={`${base} text-white font-semibold ${it.draft ? "opacity-60" : ""}`} style={{ background: st.bg }}>
        <span className="truncate">{it.title}</span>
      </button>);
  }
  return (
    <button type="button" data-testid={`cal-item-${it.uid}`} onClick={click} title={`${timeRange(it)} · ${it.title}`}
      className={`${base} hover:bg-gray-100 text-gray-800 ${clash ? "ring-1 ring-red-400" : ""} ${it.draft ? "opacity-60" : ""}`}>
      <span className="w-2 h-2 rounded-full shrink-0" style={{ background: st.bg }} />
      {!compact && <span className="font-semibold text-gray-500 shrink-0">{short12(it.start_time)}</span>}
      <span className="truncate font-medium">{it.title}</span>
      {clash && <AlertTriangle className="w-3 h-3 text-red-500 shrink-0" />}
    </button>);
}

export function BlockChip({ it, onOpen, style, small }) {
  const st = TYPES[it.type] || TYPES.event;
  const clash = (it.conflicts || []).length > 0;
  return (
    <button type="button" data-testid={`cal-block-${it.uid}`} onClick={(e) => { e.stopPropagation(); onOpen(it); }}
      className={`absolute rounded-lg px-1.5 py-1 text-left text-white overflow-hidden shadow-sm border border-white/70 hover:z-20 hover:shadow-md transition-shadow ${clash ? "ring-2 ring-red-500" : ""} ${it.draft ? "opacity-70 border-dashed" : ""}`}
      style={{ ...style, background: st.bg }} title={`${it.title} · ${timeRange(it)}`}>
      <p className="text-[11px] font-bold leading-tight truncate">{clash && <AlertTriangle className="w-3 h-3 inline mr-0.5 -mt-0.5" />}{it.title}</p>
      {!small && <p className="text-[10px] leading-tight opacity-90 truncate">{timeRange(it)}{duration(it.start_time, it.end_time) ? ` · ${duration(it.start_time, it.end_time)}` : ""}</p>}
      {!small && it.location && <p className="text-[10px] leading-tight opacity-80 truncate">{it.location}</p>}
    </button>);
}
